/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EventContextSlugs } from "./EventContextSlugs";
import { ActionName } from "./ActionName";
import { AccountId } from "../../commons/types/AccountId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SpaceId } from "../../commons/types/SpaceId";
import { WorkbookId } from "../../commons/types/WorkbookId";
import { SheetId } from "../../commons/types/SheetId";
import { SheetSlug } from "./SheetSlug";
import { SnapshotId } from "../../commons/types/SnapshotId";
import { VersionId } from "../../commons/types/VersionId";
import { CommitId } from "../../commons/types/CommitId";
import { JobId } from "../../commons/types/JobId";
import { ProgramId } from "../../commons/types/ProgramId";
import { FileId } from "../../commons/types/FileId";
import { DocumentId } from "../../commons/types/DocumentId";
import { EventId } from "../../commons/types/EventId";
import { AppId } from "../../commons/types/AppId";
import { ActionId } from "../../commons/types/ActionId";
import { DataClipId } from "../../commons/types/DataClipId";
import { ThreadId } from "../../commons/types/ThreadId";
export const Context = core.serialization.object({
    namespaces: core.serialization.list(core.serialization.string()).optional(),
    slugs: EventContextSlugs.optional(),
    actionName: ActionName.optional(),
    accountId: AccountId,
    environmentId: EnvironmentId,
    spaceId: SpaceId.optional(),
    workbookId: WorkbookId.optional(),
    sheetId: SheetId.optional(),
    sheetSlug: SheetSlug.optional(),
    snapshotId: SnapshotId.optional(),
    versionId: VersionId.optional(),
    commitId: CommitId.optional(),
    jobId: JobId.optional(),
    programId: ProgramId.optional(),
    fileId: FileId.optional(),
    documentId: DocumentId.optional(),
    precedingEventId: EventId.optional(),
    actorId: core.serialization.string().optional(),
    appId: AppId.optional(),
    actionId: ActionId.optional(),
    dataClipId: DataClipId.optional(),
    threadId: ThreadId.optional(),
    filters: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    entityId: core.serialization.string().optional(),
});
